/* eslint-disable lines-between-class-members */
import BaseModel from '@kakadu-dev/base-frontend-helpers/models/BaseModel';
import { tagZoneTypes, types } from "./enums";
/**
 * TagZone class
 */

export class TagZone extends BaseModel {
  constructor(...args) {
    super(...args);

    this.getId = () => {
      return this.model.id;
    };

    this.getTitle = () => {
      return this.model.title;
    };

    this.getZoneId = () => {
      return this.model.zoneId;
    };

    this.getCreatedAt = () => {
      return this.model.createdAt;
    };

    this.getType = (asLabel = false) => {
      return asLabel ? TagZone.tagZoneTypes[this.model.type || 'unknown'] || TagZone.tagZoneTypes['unknown'] : this.model.type;
    };
  }

  /**
   * Create tag zone
   *
   * @param {object} object
   *
   * @return {TagZone}
   */
  static create(object) {
    return super.create(object);
  }
  /**
   * Create list tag zone
   *
   * @param {object} objects
   *
   * @return {Array.<TagZone>}
   */


  static createList(objects) {
    return super.createList(objects);
  }
  /**
   * Map tag zone
   *
   * @param {Array.<object>} objects
   * @param {function(TagZone): undefined} callback
   *
   * @return {Array.<object>}
   */


  static map(objects, callback) {
    return super.map(objects, callback);
  }
  /**
   * Get tag zone id
   *
   * @return {number}
   */


}
TagZone.types = types;
TagZone.tagZoneTypes = tagZoneTypes;